<template>
  <es-layout
      layout="{{['header','footer']}}"
      click-left='{{goback}}'
      class="es-add"
      custom-class="contact-add-custom-class"
    >
    <!-- 导航栏 -->
    <view class="page-header" slot="header">
      <es-navbar class="es-add__navbar" custom-class="es-add__navbar" title="注册12306账号" leftArrow="{{false}}">
        <view wx:if="{{!isHideLeftArrow}}" slot="left">
          <es-icon size='24' color="#333333" name="angle-left"></es-icon>
        </view>
      </es-navbar>
    </view>
    <register-content 
      wx:ref="contentRef"
      isAgree="{{isAgree}}" 
      />
    <view class="bottom">
      <view class="tips es-rm-agree-box">
        <es-shake shake="{{shake}}">
          <view class="es-rm-agreement">
            <es-checkbox-group wx:model="{{checkboxValue}}" direction="row">
              <es-checkbox
                label-position="right"
                name="1"
                shap="square"
                iconSize="{{16}}"
                icon-style="{{{borderRadius: '4px'}}}"
                useIconSlot="{{true}}"
              >
                <image
                  mode="aspectFit"
                  class="es-zdy-icon"
                  wx:if="{{isAgree}}"
                  slot="icon"
                  src="https://pt-starimg.didistatic.com/static/starimg/img/d6u1QeWbMP1646634186170.png"
                >
                </image>
              </es-checkbox>
              <view class="es-rm-checkbox">我们会将您填写的上述信息提供给青岛景行科技有限公司用于注册12306账号，我们不会存储您的上述信息，您应遵守<view
                view class="span" bindtap="goto('a')">《服务协议》</view><view
                view class="span" bindtap="goto('b')">《个人信息处理授权协议》</view>
              </view>
            </es-checkbox-group>
          </view>
            <!-- <view
              bindtap="goto"
              class="es-rm-navigator es-rm-navigator-hover"
              hover-class="navigator-hover"
              >《账户授权协议》</view
            > -->
        </es-shake>
      </view>
      <view class="footer">
        <view class="submit" bindtap="save">下一步</view>
      </view>
    </view>
  </es-layout>
</template>


<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { bridge } from '@didi/webx-js'
  import { isDdPassengerH5, isALIMini, isWXMini } from '@/common/constant'
  import { innerRouter, pagePath } from "@/common/jump";
  import {
    registerConfig,
    componentsConfig
  } from '@/config/register/index'
  import { trackEvent } from '@/common/track'

  createPage({
    data: {
      checkboxValue: [],
      shake: false,
    },
    computed: {
      isHideLeftArrow() {
        return isWXMini || isALIMini
      },
      isAgree() {
        return this.checkboxValue.length ? true : false
      }
    },
    methods: {
      goback() {
        innerRouter.goback()
      },
      save(){
        if (this.$refs['contentRef']) {
          this.$refs['contentRef'].save()
        }
      },
      goto(type){
        const urlMap = {
          a: 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?s=op-json-IfG7BkbLs#/xpub',
          b: 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2\u0026policy_id=50071874',
        }
        const goToUrl = urlMap[type]
        if( isWXMini || isALIMini ){
          // 这个url有bug，带多余的参数就报错
          location.href = goToUrl
        }else{
          innerRouter.goTo(goToUrl)
        }
      }
    },
    mounted() {
      trackEvent('userteam_train_regpage_sw', 'UT-火车票-注册页面-曝光')
    }
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'
  +b('add')
    background #f0f1f4
    .page-header
      background #ffffff
    /deep/ .es-main
      background-color #f0f1f4
      margin-bottom calc(constant(safe-area-inset-bottom) + 150px)
      margin-bottom calc(env(safe-area-inset-bottom) + 150px)
    /deep/ .es-toast
      background-color #000000
      padding 12px 24px
    /deep/ .es-card__body
      padding 0 12px !important
    /deep/ .es-icon-angle-right
      font-size 20px !important
      color #999999 !important
    +e('navbar')
      background-color #ffffff
      height 44px !important
      z-index auto !important
      font-size 18px
      /deep/ .es-navbar
        height 60px
      /deep/ .es-navbar__right
        width 28px
      /deep/ .es-navbar__title
        font-size 18px
    +e('save')
      border-radius 8px !important
      font-size 16px !important
      /deep/ button
        border-radius 8px
    +e('footer')
      width 100%
      padding 16px
      background-color #ffffff
      box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
      // z-index 1

  .tips
    background linear-gradient(270deg, #FEFEFE 0%, #EDF4FF 100%)
  .es-rm-agree-box
    display flex
    justify-content space-between
    padding 8px 16px 
  .es-rm-checkbox
    font-size 12px
    color $train-color-999
    margin-left -5px
    flex 1
    .span 
      display inline
      color #1473FF

  .es-rm-navigator
    font-size 12px !important
    line-height 20px
    display block
    color $train-color-theme-blue
    margin-top 1px
    text-decoration none
    letter-spacing -1px
  .es-rm-navigator-hover
    color $train-color-theme-blue
  .es-rm-agreement
    /deep/ .es-checkbox-group--row 
      align-items flex-start
    /deep/ .es-checkbox
      margin-top 1px
  .bottom
    position fixed
    bottom 0px 
    background #ffffff
  .footer
    width 100%
    background #FFFFFF
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    .submit
      margin 16px
      height 48px
      border-radius 8px
      background #1473FF
      font-family PingFangSC-Medium
      font-size 16px
      font-weight normal
      line-height 19px
      letter-spacing: 0px
      color #FFFFFF
      display flex
      align-items center
      justify-content center

</style>

<script name='json'>
  module.exports = {
    // navigationBarTitleText: '注册12306账号',
    usingComponents: {
      "register-content":'./components/register/index',
      'es-icon': '@didi/es-mpx-ui/lib/icon/index',
      'es-layout': '@/es-mpx-ui/lib/layout',
      'es-checkbox': '@/es-mpx-ui/lib/checkbox',
      'es-checkbox-group': '@/es-mpx-ui/lib/checkbox-group',
      'es-shake': '@/components/transition-shake'
    }
  }
</script>